import { convertYoutubeAndVimeoEmbedURL } from '@/services/utils/utils.service';
import { RunComponentCommonProps } from '@/types/run-components.type';

export default function RunEmbedComponent({
  componentMapping
}: RunComponentCommonProps) {
  return (
    <div>
      {componentMapping?.component_embed?.url && (
        <div className="flex max-w-full md:max-w-[65%] flex-col border border-gray-400 rounded-md bg-white">
          <div className="flex flex-row border-b border-gray-400">
            {/* SVG Icon */}
            <div className="flex items-center p-2 border-r border-gray-400 rounded-tl-md bg-[#ffd95b]">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.4488 13.8574C12.3476 13.9595 12.2281 14.0068 12.0901 13.9992C11.9522 13.9915 11.8355 13.9367 11.7402 13.8344C11.633 13.7265 11.5795 13.6019 11.5795 13.4611C11.5795 13.3201 11.633 13.1955 11.7402 13.0876L15.7833 9.00758L11.7454 4.9329C11.6441 4.83073 11.5972 4.70624 11.6048 4.55944C11.6123 4.41265 11.6668 4.28815 11.768 4.18597C11.8751 4.07794 11.9985 4.02392 12.1381 4.02392C12.2778 4.02392 12.4011 4.07794 12.5083 4.18597L16.8045 8.53547C16.9349 8.67288 17 8.82878 17 9.00318C17 9.17757 16.9349 9.33054 16.8045 9.46208L12.4488 13.8574ZM4.50574 13.7974L0.195513 9.46208C0.065179 9.33054 0 9.17757 0 9.00318C0 8.82878 0.065179 8.67288 0.195513 8.53547L4.55113 4.14899C4.65239 4.04682 4.7743 3.99719 4.91685 4.00012C5.05943 4.00308 5.18132 4.05564 5.28257 4.15781C5.38382 4.25998 5.43445 4.383 5.43445 4.52685C5.43445 4.67072 5.38382 4.79374 5.28257 4.89591L1.21674 8.99878L5.25466 13.0735C5.35591 13.1756 5.40507 13.2963 5.40216 13.4354C5.39925 13.5747 5.34717 13.6953 5.24592 13.7974C5.13885 13.9055 5.01549 13.9595 4.87585 13.9595C4.73618 13.9595 4.61281 13.9055 4.50574 13.7974Z"
                  fill="black"
                  fillOpacity="0.6"
                />
              </svg>
            </div>

            <div className="flex w-[82%] md:w-[88%] justify-between items-center">
              {/* Embed URL */}
              <div className="flex-1 w-[88%] whitespace-nowrap line-clamp-1 pl-2">
                <a
                  href={
                    componentMapping?.component_embed?.url?.startsWith(
                      'https://'
                    ) ||
                    componentMapping?.component_embed?.url?.startsWith(
                      'http://'
                    )
                      ? componentMapping?.component_embed?.url
                      : 'https://' + componentMapping?.component_embed?.url
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#e5c04f] hover:underline"
                >
                  {componentMapping?.component_embed?.url || ''}
                </a>
              </div>
            </div>
          </div>

          {/* Embed Iframe */}
          <div className="p-2">
            <div className="w-full h-[400px] rounded-lg overflow-hidden">
              <iframe
                src={convertYoutubeAndVimeoEmbedURL(
                  componentMapping?.component_embed?.url?.startsWith(
                    'https://'
                  ) ||
                    componentMapping?.component_embed?.url?.startsWith(
                      'http://'
                    )
                    ? componentMapping?.component_embed?.url
                    : 'https://' + componentMapping?.component_embed?.url
                )}
                width="100%"
                height="100%"
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
